export default __webpack_public_path__ + "static/media/2023_Spaak_et_al_2023_Oikos.a4db056f.pdf";